import { scrollToId } from "../lib/scroll";

export default function Footer() {
  return (
    <footer
      className="relative bg-background border-t border-white/10 pt-20 pb-10"
      data-testid="footer"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 pb-16">
          <div className="md:col-span-6">
            <div className="font-serif text-3xl md:text-4xl text-foreground mb-2">
              Metodo Sintesi
            </div>
            <span className="text-[11px] tracking-[0.3em] text-primary">
              DI FRANCESCO GALLI · MENTAL COACHING & PNL
            </span>
            <p className="mt-6 max-w-md text-muted-foreground leading-relaxed">
              Dall'analisi infinita alla sintesi d'azione. Un metodo pragmatico
              per imprenditori, professionisti e atleti. Niente fuffa, solo
              risultati.
            </p>
            <button
              onClick={() => scrollToId("candidatura")}
              className="mt-8 inline-flex items-center gap-3 rounded-full bg-primary text-primary-foreground px-8 py-4 text-sm tracking-[0.12em] hover:bg-primary/90 transition-colors duration-300"
              data-testid="footer-cta"
            >
              PRENOTA LA TUA ANALISI →
            </button>
          </div>

          <div className="md:col-span-3">
            <div className="text-[11px] tracking-[0.3em] text-muted-foreground mb-6">
              NAVIGA
            </div>
            <ul className="space-y-3">
              {[
                { label: "Il Metodo", id: "metodo-sintesi" },
                { label: "Il Problema", id: "problema" },
                { label: "Aree di intervento", id: "approccio" },
                { label: "Sport", id: "sport" },
                { label: "Il Percorso", id: "metodo" },
                { label: "Filosofia", id: "filosofia" },
                { label: "Diventa Coach", id: "formazione" },
                { label: "Candidati", id: "candidatura" },
              ].map((l) => (
                <li key={l.id}>
                  <button
                    onClick={() => scrollToId(l.id)}
                    className="text-foreground/80 hover:text-primary transition-colors duration-300"
                    data-testid={`footer-link-${l.id}`}
                  >
                    {l.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <div className="text-[11px] tracking-[0.3em] text-muted-foreground mb-6">
              CONTATTI
            </div>
            <ul className="space-y-3 text-foreground/80">
              <li>
                <a
                  href="mailto:francescogallicoach@icloud.com"
                  className="hover:text-primary transition-colors duration-300"
                  data-testid="footer-email"
                >
                  francescogallicoach@icloud.com
                </a>
              </li>
              <li className="pt-2">Milano · su appuntamento</li>
              <li>Firenze · su appuntamento</li>
              <li>Roma · su appuntamento</li>
              <li>Dubai · su appuntamento</li>
              <li>Londra · su appuntamento</li>
              <li>New York · su appuntamento</li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-muted-foreground">
          <span>© {new Date().getFullYear()} Metodo Sintesi di Francesco Galli. Tutti i diritti riservati.</span>
          <span className="tracking-wide">
            <a
              href="/privacy"
              className="hover:text-primary transition-colors duration-300"
              data-testid="footer-privacy-link"
            >
              Privacy
            </a>{" "}
            · Termini · Cookie
          </span>
        </div>
      </div>
    </footer>
  );
}
